import { render, staticRenderFns } from "./NovaConsulta.vue?vue&type=template&id=1d9dbdba&scoped=true&"
import script from "./NovaConsulta.vue?vue&type=script&lang=js&"
export * from "./NovaConsulta.vue?vue&type=script&lang=js&"
import style0 from "./NovaConsulta.vue?vue&type=style&index=0&id=1d9dbdba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9dbdba",
  null
  
)

export default component.exports